import { reduxForm } from 'redux-form';
import Component from './FormAreaManagement';
import { validate } from './validate';

const initialValues = {
  code: '',
  name: '',
};

const FormAreaManagement = reduxForm({
  form: 'form-area-management',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default FormAreaManagement;
